import environment from '../environment';
import StoresControl from './StoresControl';

export class UnapprovedStoresControl extends StoresControl {
    constructor () {
        const options = {
            name: 'UnapprovedStores',
            context: 'LAYER_UNAPPROVED_STORES',
            stores: environment.get('CONFIG.DEALERS')
        };

        super(options);
    }

    static getInstance () {
        if (!UnapprovedStoresControl._instance) {
            UnapprovedStoresControl._instance = new UnapprovedStoresControl();
        }

        return UnapprovedStoresControl._instance;
    }
}

export default UnapprovedStoresControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/UnapprovedStoresControl.js